import React, { useEffect, useState } from "react";
import "./index.css";
import { Operation } from "src/api/interfaces/permissions";
import { usePermissions } from "src/components/Contexts/PermissionsContext";
import { useCountrySelection } from "src/components/Contexts/CountrySelectionContext";
import { checkPermissionOnCountry } from "../Permissions/PermissionCheckers";
import ImpersonateButton from "./ImpersonateButton";
import NestButton from "./NestButton";

interface NestNavBarProps {
  isNest?: boolean;
}

export default function NestNavBar({ isNest }: NestNavBarProps) {
  const { permissions } = usePermissions();
  const { selectedCountry } = useCountrySelection();
  const [isNestAvailable, setIsNestAvailable] = useState(false);

  useEffect(() => {
    if (!selectedCountry) {
      return;
    }
    setIsNestAvailable(
      checkPermissionOnCountry(
        permissions,
        selectedCountry.countryCode,
        Operation.PerformInternalActions
      )
    );
  }, [selectedCountry, permissions]);

  if (!isNestAvailable) {
    return null;
  }

  return (
    <div className="nest-nav-bar">
      <NestButton isNest={isNest} />
      {isNest && (
        <>
          <ImpersonateButton />
        </>
      )}
    </div>
  );
}
